import { config } from 'config';
import { fetchWrapper } from 'helpers';

const baseUrl = `${config.apiUrl}/accounts/change-client`;

export const clientService = {
    changeClient: function (id) {
        return fetchWrapper.put(baseUrl + id);
    }
};